import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CmsTarget, CmsTaxonomyGeneral } from '@fcom/core-api';

import { toLinkData } from '../../services';

interface LinkBlockContent {
  target?: CmsTarget;
  subjectTaxonomyTags?: Array<CmsTaxonomyGeneral | string>;
}

@Component({
  selector: 'cms-link-block',
  template: `
    <ng-container [ngSwitch]="linkType$ | async">
      <fin-cta-big-link
        *ngSwitchCase="'cmstyle-arrow-link'"
        [target$]="cmsTarget$"
        [teaserTitle$]="content$ | finMap: 'teaserTitle'"
        [teaserText$]="content$ | finMap: 'teaserText'"
        [layout]="'xsmall'"
        class="mr-xxsmall-b"
      />
      <fin-link-block
        class="mr-large-b block"
        [class.align-center]="isCentered$ | async"
        *ngSwitchDefault
        [target$]="cmsTarget$"
        [teaserTitle$]="content$ | finMap: 'teaserTitle'"
        [cmsTags$]="cmsTags$"
      />
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsLinkBlockComponent implements OnInit {
  @Input()
  content$: Observable<LinkBlockContent>;

  cmsTarget$: Observable<CmsTarget>;
  linkType$: Observable<string>;
  cmsTags$: Observable<Array<CmsTaxonomyGeneral | string>>;
  isCentered$: Observable<boolean>;

  ngOnInit(): void {
    this.cmsTarget$ = this.content$.pipe(map((d) => toLinkData(d.target)));

    this.cmsTags$ = this.content$.pipe(map((content) => content.subjectTaxonomyTags ?? []));

    this.linkType$ = this.cmsTags$.pipe(
      map((tags) =>
        tags.find((tag) => {
          return tag.startsWith('cmstyle-');
        })
      )
    );

    this.isCentered$ = this.cmsTags$.pipe(map((a) => a.includes(CmsTaxonomyGeneral.CENTERED)));
  }
}
